import type { MotionTimeline, EaseSpec } from '../store/types';

const easeName = (e: EaseSpec): string => (typeof e === 'string' ? e : Object.keys(e)[0]);

/** Compact, line-per-track text of a timeline for snapshots + prompt context.
 *  Round-trippable enough for the agent to read-modify-write via motion_apply. */
export function serializeTimeline(tl: MotionTimeline): string {
  const head = `motion dur=${tl.duration}ms${tl.playback.autoplay ? ` autoplay=${tl.playback.autoplay.mode}` : ''}${tl.playback.scroll ? ' scroll' : ''}${tl.playback.triggers?.length ? ` triggers=${tl.playback.triggers.map((t) => t.on).join(',')}` : ''}`;
  const lines = tl.tracks.map((tr) => {
    const chans = tr.layers.flatMap((ly) =>
      ly.channels.map((ch) => `${ly.blend === 'add' ? '+' : ''}${ch.prop}: ${ch.keyframes.map((k) => `${k.t}ms=${k.value}(${easeName(k.ease)})`).join(' ')}`),
    );
    return `  track ${tr.target}${tr.label ? ` "${tr.label}"` : ''}: ${chans.join(' | ')}`;
  });
  return [head, ...lines].join('\n');
}
